// Acknowledgments belong to this browser document, never to saved campaign state.
const documents = new WeakMap();

function storeFor(documentRef) {
  if (!documentRef || typeof documentRef !== 'object') return null;
  let store = documents.get(documentRef);
  if (!store) {
    store = { dismissed: new Set(), listeners: new Set() };
    documents.set(documentRef, store);
  }
  return store;
}

export function campaignNoticeKey({ companyId, campaignId, kind, reasonCode = '' } = {}) {
  const parts = [companyId, campaignId, kind, reasonCode];
  if (!parts.every((part) => typeof part === 'string')
    || parts.slice(0, 3).some((part) => !part.trim())) return '';
  return JSON.stringify(parts.map((part) => part.trim()));
}

export function isDocumentNoticeDismissed(key, documentRef = globalThis.document) {
  return Boolean(key && storeFor(documentRef)?.dismissed.has(key));
}

export function dismissDocumentNotice(key, documentRef = globalThis.document) {
  if (typeof key !== 'string' || !key) return false;
  const store = storeFor(documentRef);
  if (!store || store.dismissed.has(key)) return false;
  store.dismissed.add(key);
  for (const listener of [...store.listeners]) listener();
  return true;
}

export function subscribeDocumentNotices(listener, documentRef = globalThis.document) {
  const store = storeFor(documentRef);
  if (!store) return () => {};
  store.listeners.add(listener);
  return () => store.listeners.delete(listener);
}
